import React, { useEffect, useRef } from "react";
import { useRollbar } from "@rollbar/react";
import { useIncode } from "./IncodeContext";
import { isEmpty } from "lodash";

interface Props {
  name: string;
  next: string;
}

export function Step({ name, next }: Props) {
  const containerRef = useRef(null);
  const { incode, token, track, navigateTo, onComplete } = useIncode();
  const rollbar = useRollbar();

  useEffect(() => {
    incode.renderCamera(name, containerRef.current, {
      onSuccess: async () => {
        if (name === "selfie") {
          try {
            await incode.getFinishStatus(null, { token });
            track("selfie_success");
            onComplete();
          } catch (error) {
            rollbar.error("Incode Selfie Error", error);
            track("selfie_error");
          }
        }
        track(`${name}_success`);
        if (!isEmpty(next)) {
          navigateTo(next);
        }
      },
      onError: async (error: any) => {
        rollbar.error("Incode Render Camera Error", error);

        if (error.type === "permissionDenied") {
          track(`${name}_permissions_error`);
          navigateTo("enable_camera_access");
          return;
        }

        track(`${name}_error`);
        navigateTo(next);
      },
      token: { token },
      // TODO - remove when incode implements the configured flow for these
      numberOfTries: 5,
      timeout: 19000,
      isRecordingEnabled: true,
    });
  }, [name, next, incode, token, track, navigateTo, rollbar, onComplete]);

  return <div ref={containerRef} />;
}
